import React from "react";
import { PendingRolloverin } from "../../../containers";

const ManageRolloverin = (props) => {
  return <PendingRolloverin {...props} />;
};

export default ManageRolloverin;
